module.exports = __webpack_public_path__ + "06967205566e56fd4c78b0ca659dc94c.jpg";